/**
 * Maps navigation hrefs to their corresponding RBAC modules
 * Used for permission-based navigation filtering
 */
export const HREF_TO_MODULE_MAP: Record<string, string> = {
  // Main navigation
  '/assessment': 'assessment',
  '/dashboard': 'dashboard',
  '/successors': 'successors',
  '/consultants': 'consultants',
  '/clients': 'clients',
  '/company': 'company',
  '/valuations': 'valuations',
  '/benchmarks': 'benchmarks',
  '/team': 'team',
  '/plan': 'plan',
  '/tasks': 'tasks',
  '/documents': 'documents',
  '/learn': 'learn',
  '/reports': 'reports',
  '/settings': 'settings',
  
  // Settings navigation
  'appearance': 'settings_appearance',
  'notifications': 'settings_notifications',
  'security': 'settings_security',
  'billing': 'settings_billing',
  'export': 'settings_export',
  'company-information': 'company',
  
  // Platform admin routes (optional - admins bypass RBAC anyway)
  '/admin': 'platform_admin',
  '/admin/organizations': 'platform_admin',
  '/admin/users': 'platform_admin',
  '/admin/audit': 'platform_admin',
  '/admin/settings': 'platform_admin',
};
